<div class="idp__banner idp__banner--split" [ngStyle]="containerStyle">
  <div
    class="banner-row banner-row-container margin-0"
    [ngClass]="bannerRowClass"
  >
    <ng-container
      *ngIf="
        desktopBannerEnabled &&
        content.imageContent &&
        content.imageContent.desktop
      "
    >
      <div
        class="idp__banner--split-imageplaceholder idp__banner--desktop banner-d-sm-none banner-d-md-block banner-col-md-6 banner-col-lg-7 banner-col-xl-7"
      >
        <idp-banner-image
          [content]="content.imageContent.desktop"
        ></idp-banner-image>
      </div>
    </ng-container>

    <ng-container
      *ngIf="
        mobileBannerEnabled &&
        content.imageContent &&
        content.imageContent.mobile
      "
    >
      <div
        class="idp__banner--split-imageplaceholder idp__banner--mobile banner-d-none banner-d-sm-block banner-d-md-none"
        [ngClass]="mobileBannerClasses"
      >
        <idp-banner-image
          [content]="content.imageContent.mobile"
        ></idp-banner-image>
      </div>
    </ng-container>

    <ng-container
      *ngIf="
        tabletBannerEnabled &&
        content.imageContent &&
        content.imageContent.tablet
      "
    >
      <div
        class="idp__banner--split-imageplaceholder idp__banner--tablet banner-d-sm-none banner-d-md-block banner-col-sm-5"
      >
        <idp-banner-image
          [content]="content.imageContent.tablet"
        ></idp-banner-image>
      </div>
    </ng-container>
    <div class="idp__banner--split-content banner-col">
      <div class="banner-row margin-0">
        <div class="banner-col-12 padding-0">
          <div class="banner-row margin-0">
            <div class="banner-col-12 padding-0 header-col">
              <idp-heading
                *ngIf="!!content.headerText"
                [styles]="headerStyles"
                [content]="headerContent"
              ></idp-heading>
            </div>
            <ng-container *ngIf="!!content.description">
              <div class="banner-col-12 padding-0">
                <idp-banner-text
                  *ngIf="styles && styles.description"
                  class="idp__banner--split-subheading"
                  [styles]="styles.description"
                  [content]="content.description"
                ></idp-banner-text>
              </div>
            </ng-container>

            <ng-container
              *ngIf="content.moreText && content.moreText !== '&nbsp;'"
            >
              <div class="banner-col-12 padding-0">
                <idp-banner-text
                  *ngIf="styles && styles.moreinfo"
                  class="idp__banner--split-moretext"
                  [styles]="styles.moreinfo"
                  [content]="content.moreText"
                ></idp-banner-text>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
